import { render, staticRenderFns } from "./ButtonPrimaryForwardChip.vue?vue&type=template&id=db8a979a&scoped=true"
import script from "./ButtonPrimaryForwardChip.vue?vue&type=script&lang=js"
export * from "./ButtonPrimaryForwardChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8a979a",
  null
  
)

export default component.exports